module.exports = __webpack_public_path__ + "img/iplimit01.1629de2e.png";